import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {sizeArray, getInitial, userShape} from './utils';

import OutputText from '@ey/canvascoreservices/OutputText';

import Avatar from './Avatar';
import StyledUser from './StyledUser';
import {labels} from '../../../util/utils';

const User = ({
	email = null,
	firstName = null,
	lastName = null,
	isInternal = null,
	showType = false,
	renderExtra = null,
	showPresence = false,
	showInfo = true,
	showAside = true,
	showTitle = true,
	size = 'md'
}) => {
	const user = {
		email,
		firstName,
		lastName,
		initials: `${!!firstName ? getInitial(firstName) : ''}${!!lastName ? getInitial(lastName) : ''}`,
		displayName: `${firstName ?? ''}${!firstName || !lastName ? '' : ' '}${lastName ?? ''}`,
		isInternal
	};

	const showSecondLine = !!showType || !!renderExtra;

	const renderDisplayName = () => {
		const text = user?.displayName;

		return (
			<OutputText body2 ellipsis title={text}>
				{text}
			</OutputText>
		);
	};

	const renderType = () => {
		let text = null;
		if (user?.isInternal === true) text = labels.internal;
		if (user?.isInternal === false) text = labels.external;

		return (
			text && (
				<OutputText body2 light ellipsis title={text} className="type">
					{text}
				</OutputText>
			)
		);
	};

	const props = {
		className: classNames('user', size, {internal: isInternal === true, external: isInternal === false})
	};

	const avatarProps = {
		user,
		showPresence,
		showInfo,
		showTitle
	};

	return (
		<StyledUser {...props}>
			<Avatar {...avatarProps} />
			{showAside && (
				<aside>
					{renderDisplayName()}
					{showSecondLine && (
						<div>
							{showType && renderType()}
							{renderExtra && renderExtra()}
						</div>
					)}
				</aside>
			)}
		</StyledUser>
	);
};

User.propTypes = {
	email: userShape.email,
	firstName: userShape.firstName,
	lastName: userShape.lastName,
	isInternal: userShape.isInternal,

	showType: PropTypes.bool,
	renderExtra: PropTypes.func,
	showInfo: PropTypes.bool,
	showPresence: PropTypes.bool,
	showAside: PropTypes.bool,
	showTitle: PropTypes.bool,
	size: PropTypes.oneOf(sizeArray)
};

export default User;
